<template>
  <div
    class="noNewsData keep-hue"
    :class="{'module': type === 'module', 'center': type === 'center'}"
  >
    <img :src="require(`@/assets/Service/noneT@2x.svg`)" />
    <p>没有相关内容</p>
  </div>

</template>

<script>
export default {
  name: "noData",
  props: {
    type: { type: String, default: "list" },
  },
};
</script>

<style scoped lang="scss">
.noNewsData {
  box-sizing: border-box;
  width: 100%;
  margin-top: 120px;
  border-radius: 6px;
  img {
    height: auto;
    display: block;
    margin: 0 auto;
    width: 120px;
  }
  p {
    font-size: 14px;
    color: #111111;
    line-height: 14px;
    margin-top: 20px;
    text-align: center;
    text-shadow: 0px 0px 8px rgba(255, 255, 255, 0.3);
  }
  &.module {
    margin-top: 102px;
    img {
      max-width: 240px;
    }
  }
  &.center {
    /*margin-top: 0px;*/
    /*width: 100%;*/
    /*height: 100%;*/
    /*display: flex;*/
    /*flex-direction: column;*/
    /*justify-content: center;*/
    /*align-items: center;*/
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    margin-top: 0px;
    width: 120px;

  }
}
</style>